import { Dispatch } from 'redux';
import { AdminApi } from '../../../api/api.apiclient';
import {
  DELETE_NOTIFICATION,
  GET_NOTIFICATION,
  GET_NOTIFICATIONS_LIST,
  POST_NOTIFICATION,
  PUT_NOTIFICATION
} from '../types/notification.types';
import { NotificationRequestModel } from '../../../api/admin/admin.types';

export const getNotifications =
  () => async (dispatch: Dispatch<any>) => {

    const response = await AdminApi.notifications.getNotificationsList();

    dispatch({
      type: GET_NOTIFICATIONS_LIST,
      payload: {
        page: response.data
      }
    });

    return Promise.resolve();
  };

export const getNotification =
  (id: number) => async (dispatch: Dispatch<any>) => {

    const response = await AdminApi.notifications.getNotification(id);
    dispatch({
      type: GET_NOTIFICATION,
      payload: {
        selectedNotification: response.data
      }
    });

    return Promise.resolve();
  };

export const addNewNotification =
  (request: NotificationRequestModel) => async (dispatch: Dispatch<any>) => {

    const response = await AdminApi.notifications.addNewNotification(request);

    dispatch({
      type: POST_NOTIFICATION,
      payload: { selectedNotification: response.data }
    });

    return Promise.resolve();
  };

export const editNotification =
  (request: NotificationRequestModel, id: number) => async (dispatch: Dispatch<any>) => {

    const response = await AdminApi.notifications.editNotification(request, id);

    dispatch({
      type: PUT_NOTIFICATION,
      payload: { selectedNotification: response.data }
    });

    return Promise.resolve();
  };

export const deleteNotification = (id: number) => async (dispatch: Dispatch<any>) => {
  await AdminApi.notifications.deleteNotification(id);
  dispatch({
    type: DELETE_NOTIFICATION,
    payload: {
      selectedNotification: null
    }
  });
};


